import {JobsToBeDonePage} from '@features/jobs-to-be-done'
import {PermissionType} from '@hconnect/apiclient'
import {PageTitle} from '@hconnect/uikit/src/lib2'
import {Stack} from '@mui/material'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {useParams} from 'react-router'

import {useTrackJobsToBeDoneReportingAnalyticsEvent} from '../../../performanceDashboard/helpers'
import {JobsToBeDoneReportingEventName} from '../../../performanceDashboard/helpers/trackJobsToBeDoneReportingEvents'
import {useTranslationPrefix} from '../../../shared/hooks'
import {PlantSelectBreadcrumbMultiplePermissions} from '../../components'

type TitleProps = {
  title: React.ReactNode
  breadcrumbs?: React.ReactNode
}

const Title = ({title, breadcrumbs}: TitleProps) => {
  return (
    <Stack>
      {breadcrumbs}
      <PageTitle ml={0}>{title}</PageTitle>
    </Stack>
  )
}

type PathParameter = {
  plantId: string
}

type Props = {
  permissions: PermissionType[]
}

export const JobsToBeDoneDashboard = ({permissions}: Props) => {
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('plantId is missing')

  const {t} = useTranslation()
  const {hrocPrefix} = useTranslationPrefix()

  const trackJobsToBeDoneReportingDashboard = useTrackJobsToBeDoneReportingAnalyticsEvent()
  useEffect(() => {
    trackJobsToBeDoneReportingDashboard(
      JobsToBeDoneReportingEventName.UserEntersJobsToBeDoneReporting,
      {}
    )
  }, [trackJobsToBeDoneReportingDashboard])

  return (
    <JobsToBeDonePage
      plantId={plantId}
      inverted
      titleSlot={
        <Title
          title={t(`${hrocPrefix}.jobsToBeDoneDashboard.pageTitle`)}
          breadcrumbs={
            <PlantSelectBreadcrumbMultiplePermissions permissions={permissions} sx={{ml: 0}} />
          }
        />
      }
    />
  )
}
